/* eslint-disable */

export const routeInstanceDocId = (routeId, runDate) => `${routeId}__${runDate}`;

export const ROUTE_WEEKDAY_LABELS = ["日", "一", "二", "三", "四", "五", "六"];

export function nextRunDatesForWeekdays(weekdays, horizonDays = 21) {
  const set = new Set((weekdays || []).map(Number));
  const out = [];
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  for (let i = 0; i < horizonDays; i++) {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    if (set.has(d.getDay())) {
      out.push(d.toISOString().slice(0, 10));
    }
  }
  return out;
}

export function formatRunDateLabel(iso) {
  if (!iso) return "";
  const [y, m, day] = iso.split("-").map(Number);
  const d = new Date(y, m - 1, day);
  const wd = ROUTE_WEEKDAY_LABELS[d.getDay()];
  return `${iso}（週${wd}）`;
}

export function weekdaysSummary(weekdays) {
  if (!weekdays?.length) return "—";
  return [...weekdays].sort((a, b) => a - b).map((d) => `週${ROUTE_WEEKDAY_LABELS[d]}`).join("、");
}

/** 本地今日 YYYY-MM-DD（用於日期輸入同比較） */
export function todayIsoLocal() {
  const t = new Date();
  const y = t.getFullYear();
  const m = String(t.getMonth() + 1).padStart(2, "0");
  const d = String(t.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/**
 * 乘客可預留嘅出發日子（ISO 字串）
 * - 每週路線：未來 horizonDays 內符合星期嘅日子
 * - 單次路線：淨係嗰一日（未過期先）
 */
export function getBookableDatesForRoute(route, horizonDays = 21) {
  if (!route) return [];
  if (route.routeKind === "oneOff") {
    const rd = route.runDate;
    if (!rd || typeof rd !== "string") return [];
    const today = todayIsoLocal();
    if (rd < today) return [];
    return [rd];
  }
  return nextRunDatesForWeekdays(route.weekdays || [], horizonDays);
}

/** 列表／卡片一行簡述（每週 vs 單次） */
export function routeScheduleSummary(route) {
  if (!route) return "—";
  if (route.routeKind === "oneOff" && route.runDate) {
    return `單次 · ${formatRunDateLabel(route.runDate)}`;
  }
  const ws = weekdaysSummary(route.weekdays);
  return ws !== "—" ? `${ws}（每週重複）` : "—";
}
